import {TheCrypt} from "../../TheCrypt";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

export class FreespinOutroPresentation implements FlowStatePresentation {
    name: string = "FreespinOutroPresentation";
    private _flowStateController: FlowStateController;

    shouldRun(): boolean {
        return !TheCrypt.model.isNormal && TheCrypt.model.isNextNormal;
    }

    start(controller: FlowStateController): void {
        this._flowStateController = controller;
        const tl: TimelineLite = TheCrypt.freespinOutro.show(() => this.complete(), TheCrypt.apiPlugin.isReplay);
    }

    public complete():void {
        this._flowStateController.finish();
        TheCrypt.keypadPlugin.setZeroBetSpinCounter(-1);
        TheCrypt.keypadPlugin.show();
        TheCrypt.collectors.reset();
        TheCrypt.setMode(TheCrypt.model.data.nextMode);
    }
}